import {
  IGameCommunicationProcessor,
  GameCommunicationMessageType,
} from '@pp/core/src/controllers/gameCommunication/types';

import { GameStore } from '../../../store/GameStore';
import { highflyerGameStateActions } from '../../../store/slices/highflyerGame/slice';
import { LeaderBoardType } from '../../../store/slices/highflyerGame/types';

export class GameCommunicationLeaderBoardProcessor implements IGameCommunicationProcessor {
  messageName = 'hf_lb';
  delay = 0;

  process(message: GameCommunicationMessageType & LeaderBoardType, store: GameStore): void {
    const processDelay: number = 0;

    setTimeout(() => {
      this.handleBetsStats(message, store);
    }, processDelay);
  }

  private handleBetsStats(message: LeaderBoardType, store: GameStore): void {
    store.dispatch(highflyerGameStateActions.setLeaderBoardHistory(message));
  }
}
